import React from "react";
import no_data_found from "../../assets/images/imgNo-removebg-preview.png";
import { Button, Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useIds } from "../../hook/AdminContext";

export default function RecordNotFound2({
  title,
  showBackButton = true,
  showSupportButton = false,
  html,
}) {
  const { adminSetting, handleEmailClick } = useIds();

  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "50vh",
        textAlign: "center",
        p: 3,
      }}
    >
      <Box
        sx={{
          p: 3,
          borderRadius: 2,
          display: "inline-flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img
          className="no-data-image"
          src={no_data_found}
          alt="No Data Found"
          style={{
            width: "200px",
            height: "auto",
            marginBottom: "16px",
          }}
        />
        {html ? (
          <div dangerouslySetInnerHTML={{ __html: html }}></div>
        ) : (
          <Typography variant="h6" sx={{ mb: 3 }}>
            {title || "No records found"}
          </Typography>
        )}
        {showBackButton && (
          <Button
            variant="contained"
            onClick={() => navigate(-1)}
            sx={{
              mt: 2,
              textTransform: "none",
              px: 4,
              py: 1,
            }}
          >
            Go Back
          </Button>
        )}
        {showSupportButton && (
          <button
            className="theme-button-contained"
            onClick={(e) => {
              e.stopPropagation();
              handleEmailClick(adminSetting?.contact_us_support_email_for_website);
            }}
          >
            Contact Support
          </button>
        )}
      </Box>
    </Box>
  );
}
